import React, { useState, useEffect } from 'react';
import { message, Modal, notification, Spin } from 'antd';
import closeSvg from "../../../assets/common/close.svg";
import demoUser from "../../../assets/common/demoUser.svg";
import CustomCheckBox from "../../Forms/CheckBoxVarients/CustomCheckBox";
import SecondaryButton from '../../Buttons/SecondaryButton';
import PrimaryButton from '../../Buttons/PrimaryButton';
import ModalSection from "./ModalSection";
import { useDispatch, useSelector } from 'react-redux';
import { documentuserShareList, fetchAllInvestorApi, shareDocumentsApi } from '../../../features/dataRoomSlice';
import SurpriseInfo from "../../SVG/SurpriseInfo.svg";

const MoveToInvestorModal = ({ isOpen, onClose, documentList }) => {
    const [usersSelected, setUsersSelected] = useState([]);
    const [modalOpen, setModalOpen] = useState(false);
    const [modalVisible, setModalVisible] = useState(false);
    const [modalTitle, setModalTitle] = useState("");
    const [investorList, setInvestorList] = useState([]);
    const [loading, setLoading] = useState(false); // Loading state
    const [mainloading, setMainLoading] = useState(false)
    const dispatch = useDispatch();
    
    useEffect(() => {
        const fetchInvestors = async () => {
            setLoading(true);
            try {
                const result = await dispatch(fetchAllInvestorApi());
                const documentShareDetails = await dispatch(documentuserShareList({ addFolder: "", documentId: documentList._id ? documentList._id : documentList }));
                
                if (result.payload && result.payload.users) {
                    const sharedEmails = documentShareDetails.payload.sharingList.map((value) => value.sharedUserId.email);
                    console.log(sharedEmails)
                    const filteredInvestors = result.payload.users.filter(user => !sharedEmails.includes(user.email));
                    setInvestorList(filteredInvestors);
                }
            } catch (error) {
                console.error('Error fetching investors:', error);
            } finally {
                setLoading(false);
            }
        };
        
        fetchInvestors();
    }, [dispatch, documentList]);
    
    useEffect(() => {
        setModalOpen(isOpen);
    }, [isOpen]);
    
    const userHandler = (user) => {
        const isSelected = usersSelected.some((selectedUser) => selectedUser._id === user._id);
        if (isSelected) {
            setUsersSelected(usersSelected.filter((selectedUser) => selectedUser._id !== user._id));
        } else {
            setUsersSelected([...usersSelected, user]);
        }
    };
    
    const handleOk = () => {
        setModalOpen(false);
        // onClose();
    };
    
    const handleCancel = () => {
        setModalOpen(false);
        onClose();
    };
    
    const handleShare = async () => {
        setMainLoading(true);
        try {
            const userIdList = usersSelected.map(user => user._id);
            const id = documentList._id ? documentList._id : documentList;
            const body = {
                documentId: id,
                userIdList: userIdList
            };
            await dispatch(shareDocumentsApi(body)).then((response) => {
                if(response?.meta.requestStatus === "fulfilled") {
                    // notification.info({
                    //     message: "Success",
                    //     description: "Selected users have been granted access"
                    // })
                    message.success("Selected users have been granted access")
                } else {
                    // notification.error({
                    //     message: "Error",
                    //     description: "Failed to Grant Access to the Users. Please try again."
                    // })
                    message.error("Failed to Grant Access to the Users. Please try again.")
                }
                handleOk()
            });
        } catch (error) {
            console.error('Error sharing documents:', error);
        } finally {
            setMainLoading(false);
            setModalTitle("Info")
            setModalVisible(true)
        }
    };

    const handleSubmit = async () => {
        await handleShare();
        setModalOpen(false);
        setModalTitle("Access Info");
        setModalVisible(true);
    };
    
    const handleAddInvestor = () => {
        setModalOpen(false);
        setModalTitle("Edit Investor Details");
        setModalVisible(true);
    };
    
    return (
        <>
            {modalVisible && (
                <ModalSection 
                    title={modalTitle} 
                    closeHandler={() => { 
                        setModalVisible(false); 
                        handleCancel(); 
                    }}
                    text={"File has been moved to investor dashboard"}
                />
            )}
            <Modal
                title={<span style={{ fontSize: '18px' }}>{investorList.length > 0 ? "Select one investor at a time to share this folder with" : ""}</span>}
                centered
                visible={modalOpen}
                onOk={handleOk}
                onCancel={handleCancel}
                footer={null}
            >
                <button 
                    className='absolute top-4 right-3 cursor-pointer opacity-70 hover:opacity-100 transition-all' 
                    onClick={handleCancel}
                >
                    <img src={closeSvg} alt="Close" />
                </button>
                <div className="px-2 flex flex-col gap-3">
                    <div className="flex flex-col gap-4 max-h-[200px] overflow-y-auto hide-scrollbar mt-5">
                        {loading ? (
                            <div className="flex justify-center items-center h-full">
                                <div role="status">
                                    <svg aria-hidden="true" class="inline w-10 h-10 text-gray-200 animate-spin fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
                                        <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
                                    </svg>
                                    <span class="sr-only">Loading...</span>
                                </div>
                            </div>
                        ) : investorList.length === 0 ? (
                            <div className="flex justify-center items-center h-full flex-col">
                                <div className="flex justify-center items-center relative">
                                    <img src={SurpriseInfo} alt="Surprise Info" style={{ width: '80px', height: '80px' }} />
                                </div>
                                <p className='font-semibold pt-4 text-md text-neutral-500 text-center'>Oops! It looks like there are no investors added yet. To continue, please add investors first.</p>
                            </div>
                        ) : (
                            investorList.map((user) => (
                                <div key={user._id} className="flex w-full p-2 justify-between items-center">
                                    <div className="flex items-center justify-center flex-row gap-2">
                                        <img src={demoUser} alt="user" className="border mr-1" />
                                        <h1 className="text-[#424242] text-[16px] font-medium my-auto">{user.email}</h1>
                                    </div>
                                    <CustomCheckBox
                                        isChecked={usersSelected.some((selectedUser) => selectedUser._id === user._id)}
                                        handleOnClick={() => userHandler(user)}
                                    />
                                </div>
                            ))
                        )}
                    </div>
                    <div className={`w-full flex flex-row ${investorList.length > 0 ? "justify-between" : "justify-center"} mt-3`}>
                        <div>
                            {investorList.length > 0 ? (
                                <SecondaryButton text={"Add Investor"} onClick={handleAddInvestor} size="Medium" isDisabled={mainloading || loading}/>
                            ): (
                                <PrimaryButton text={"Add Investor"} onClick={handleAddInvestor} size="Medium" isDisabled={mainloading || loading}/>
                            )}
                        </div>
                        {investorList.length > 0 && (
                            <div>
                                <PrimaryButton 
                                    text={"Grant Access"} 
                                    size="Medium" 
                                    onClick={handleSubmit} 
                                    isDisabled={mainloading || usersSelected.length === 0} 
                                    isLoading={mainloading}
                                />
                            </div>
                        )}
                    </div>
                </div>
            </Modal>
        </>
    );
};

export default MoveToInvestorModal;

